module.exports = __webpack_public_path__ + "media/images/posts/wedding_planning_tasks1-a30b27b8129fa532670f7050121a9927.png";